import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import Box from "@/components/Box"
import Typography from "@/components/Typography"
import Flex from "@/components/Flex"
import { DownloadCTA } from "../components/DownloadCTA"
import { QRDownloadBtn } from "@/components/QRDownloadBtn"

export const DownloadAppBlock = () => {
  const { t, i18n } = useTranslation("payCustomer")
  const [isQRCodeOpen, setQRCodeOpen] = useState(false)

  return (
    <Box
      width={["100%", 728, 258]}
      height={["auto", "auto", 360]}
      borderRadius={16}
      padding={[3, 2, "24px 16px"]}
      bg={"#EAEEF4"}
    >
      <Box
        display={["none", "none", "flex"]}
        flexDirection={"column"}
        alignItems={"center"}
        height={"100%"}
      >
        <Typography
          mb={"auto"}
          textAlign={isQRCodeOpen ? "center" : "left"}
          variant="p"
          as="h3"
          color={"#0B1426"}
          fontWeight={600}
          fontSize={isQRCodeOpen ? 20 : 28}
          lineHeight={"140%"}
        >
          {isQRCodeOpen
            ? t("newMerchant.scan_to_download")
            : t("newMerchant.button_description")}
        </Typography>
        <Box width={"100%"} className="pay-cta-shop-now">
          <QRDownloadBtn
            isQRCodeOpen={isQRCodeOpen}
            setQRCodeOpen={setQRCodeOpen}
            ctaText={t("newMerchant.button")}
            qrCodeType={"mainApp"}
            color="#F7F9FA"
            background="#010118"
            qrCodeSize={226}
            campaign="pay"
            isShowOneLinkQR
          />
        </Box>
      </Box>
      <Box
        display={["flex", "flex", "none"]}
        flexDirection={["column", "row"]}
        alignItems={["center", "center"]}
        justifyContent={["center", "space-between"]}
      >
        <Typography
          mb={[4, 0]}
          variant="p"
          as="h3"
          color={"#0B1426"}
          fontWeight={600}
          fontSize={24}
          lineHeight={"140%"}
          maxWidth={["unset", 298]}
        >
          {t("newMerchant.button_description")}
        </Typography>
        <Flex className="pay-cta-shop-now">
          <DownloadCTA
            text={t("newMerchant.button")}
            curLang={i18n.language}
            color={"white"}
            bg={"#0B1426"}
            campaign="pay"
          />
        </Flex>
      </Box>
    </Box>
  )
}
